import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FlowBaseUrlEnum } from '@constants/app.constants';
import { Booking } from '@models/booking.models';
import { CoverGeniusCommitRequest } from '@models/requests/cover-genius-commit-request.model';
import { ApiResponse } from '@models/responses/api-response.model';
import { CoverGeniusQuoteResponse } from '@models/responses/cover-genius-quote-response.model';
import { EnvironmentService } from '@services/environment-service/environment.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CoverGeniusService {
  private static readonly CONTROLLER_ROOT = 'v1/covergenius';

  constructor(private httpClient: HttpClient) {}

  createQuote(
    bookingFlow: FlowBaseUrlEnum,
  ): Observable<ApiResponse<CoverGeniusQuoteResponse>> {
    const endpoint = `${EnvironmentService.environment.apiBaseUrl}${CoverGeniusService.CONTROLLER_ROOT}?bookingFlow=${bookingFlow}`;
    return this.httpClient.post<ApiResponse<CoverGeniusQuoteResponse>>(
      endpoint,
      null,
    );
  }

  select(request: CoverGeniusCommitRequest): Observable<ApiResponse<Booking>> {
    const endpoint = `${EnvironmentService.environment.apiBaseUrl}${CoverGeniusService.CONTROLLER_ROOT}/select`;
    return this.httpClient.post<ApiResponse<Booking>>(endpoint, request);
  }
}
